import React from 'react';
import { connect } from 'react-redux';
import { pdfService } from '_services';
import { Link } from 'react-scroll';
import { bindActionCreators } from 'redux';
import { noteActions, patientActions } from '_actions';
import { BanButton, CalcButton, DBDateField, DBDropDown, PatientDot, PdfButton, SaveButton, StatusCritical, DoubleCheckButton, LoadingIcon, CancelButton, ApplyButton, DBTextAreaNoCharges } from '_components';
import { NoteValidationEngine } from '_helpers';
import styles from './Common.module.css'
import { PatientCareCenterNoteChargesGroup } from './Group';
import { ComputedCharges } from './ComputedCharges';
import { ActualCharges } from '../../Charges/ActualCharges';
import { format } from 'date-fns';


class PatientCareCenterNoteChargesBody extends React.Component {

    computeCharges() {
        if (!this.props.alErrors && !this.props.groupErrors) {
            this.props.computeCharges(this.props.noteId);
        }
        if (this.props.noChargesVisible) {
            this.props.setNoChargesVisible({ noteId: this.props.noteId, visible: false });
            if (this.props.noChargeReason) {
                this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'NOCHARGEREASON');
            }
        }
    }

    downloadPDF() {
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        pdfService.raw(this.props.noteId)
            .then(response => response.blob())
            .then(blobby => {
                let objectUrl = window.URL.createObjectURL(blobby);
                anchor.href = objectUrl;
                anchor.download = ""
                anchor.click();
                window.URL.revokeObjectURL(objectUrl);
            });
    }


    saveFinal(checkDate) {
        if (!this.props.scribing) {
            if (this.props.chargesExist) {
                checkDate = false;
            }
            this.props.saveFinal(this.props.noteId, this.props.epno, checkDate, this.props.trtdate);
            if (this.props.pdfNewWindow && this.props.noteType !== 2 && !this.props.chargeExist) {
                this.downloadPDF();
            }
        }
    }

    cancel() {
        this.props.clearAptDate(this.props.noteId);
    }

    validateNote() {
        this.props.toggleValidationVisibility({ noteId: this.props.noteId, visible: true });
    }

    printPreview() {
        this.props.openPdf(this.props.noteId);
    }

    noCharges() {
        if (this.props.noChargesVisible) {
            this.props.setNoChargesVisible({ noteId: this.props.noteId, visible: false });
            if (this.props.noChargeReason) {
                this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'NOCHARGEREASON');
            }
        } else {
            this.props.setNoChargesVisible({ noteId: this.props.noteId, visible: true });
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    checkNoteWarnings(date) {
        //PN or PN/DN only
        if (this.props.noteType === 3 || this.props.noteType === 5) {
            this.props.getNoteWarnings(this.props.epno, this.props.noteId, format(date, 'MM/dd/yyyy'));
        }
    }


    render() {
        let chargeNoteTypes = [1, 2, 5, 6];
        return (
            <div className={styles.body_wrapper}>
                <div className={styles.row}>
                    <div className={styles.body_left}>
                        {this.props.isStudent && !this.props.scribing &&
                            <div className={styles.row}>
                                <span className={styles.body_left_col1_req}>Clinical Instructor:</span>
                                <span className={styles.body_left_col2}>
                                    <DBDropDown
                                        noteId={this.props.noteId}
                                        entity={this.props.table}
                                        entityKeyColumn={this.props.prefix + 'NO'}
                                        entityKeyValue={this.props.pk}
                                        field={this.props.prefix + 'CITHNO'}
                                        className={styles.supv_dropdown}
                                        customOptions={this.props.ciOptions}
                                        defaultValue={this.props.clinicalInstructor}
                                    />
                                </span>
                            </div>
                        }

                        {!this.props.scribing && this.props.showSupervising &&
                            <div className={styles.row}>
                                <span className={this.props.islicensed ? styles.body_left_col1 : styles.body_left_col1_req}>Supervising Therapist:</span>
                                <span className={styles.body_left_col2}>
                                    <DBDropDown
                                        noteId={this.props.noteId}
                                        entity={this.props.table}
                                        entityKeyColumn={this.props.prefix + 'NO'}
                                        entityKeyValue={this.props.pk}
                                        field={this.props.prefix + 'THNOSUPV'}
                                        className={styles.supv_dropdown}
                                        customOptions={this.props.supvOptions}
                                    />
                                </span>
                            </div>
                        }

                        {chargeNoteTypes.includes(this.props.noteType) &&
                            <div className={styles.row}>
                                <span className={styles.body_left_col1_req}>Treatment Date:</span>
                                <span className={styles.date_col}>
                                    <DBDateField
                                        noteId={this.props.noteId}
                                        entity={this.props.table}
                                        entityKeyColumn={this.props.prefix + 'NO'}
                                        entityKeyValue={this.props.pk}
                                        maxDate={new Date()}
                                        field={this.props.prefix + 'TRTDATE'}
                                        handleValueChange={(date) => this.checkNoteWarnings(date)}
                                    />
                                </span>
                            </div>
                        }
                        {!chargeNoteTypes.includes(this.props.noteType) &&
                            <div className={styles.row}>
                                <span className={styles.body_left_col1_req}>Measurement Date:</span>
                                <span className={styles.date_col}>
                                    <DBDateField
                                        noteId={this.props.noteId}
                                        entity={this.props.table}
                                        entityKeyColumn={this.props.prefix + 'NO'}
                                        entityKeyValue={this.props.pk}
                                        maxDate={new Date()}
                                        field={this.props.prefix + 'MEASUREMENTDATE'}
                                    />
                                </span>
                            </div>
                        }

                    </div>
                    <div className={styles.body_middle} />
                    <div className={styles.body_right}>
                        <div className={styles.row}>
                            <span className={styles.body_left_col1}>Discipline:</span>
                            <span className={styles.body_left_col2}>
                                {this.props.admission.discipline}
                            </span>
                        </div>
                        <div className={styles.row}>
                            <span className={styles.body_left_col1}>DOT:</span>
                            <span className={styles.body_left_col2}>
                                <PatientDot id={this.props.admission.dot} className={styles.patient_dot} />{this.props.colorName}
                            </span>
                        </div>

                        <div className={styles.row}>
                            <span className={styles.body_left_col1}>Payer Info:</span>
                            <span className={styles.body_left_col2}>
                                {Object.keys(this.props.insured)
                                    .map(id => {
                                        const i = this.props.insured[id];
                                        return (
                                            <div key={i.id}>
                                                <span title={i.payerName + ' - ' + i.contractName}>
                                                    {i.position + ' - ' + i.payerName}
                                                </span>
                                            </div>
                                        )
                                    })
                                }
                            </span>
                        </div>
                    </div>
                </div>

                {this.props.isGroup && chargeNoteTypes.includes(this.props.noteType) &&
                    <PatientCareCenterNoteChargesGroup />
                }

                <div id='charges_compute'>
                    {chargeNoteTypes.includes(this.props.noteType) && !this.props.chargesExist &&
                        <span className={styles.button}>
                            <CalcButton size='large' title='Compute Charges' onClick={() => this.computeCharges()} />
                        </span>
                    }
                    <span className={styles.button}>
                        <PdfButton size='large' color='blue' title='Print Preview' onClick={() => this.printPreview()} />
                    </span>
                    {chargeNoteTypes.includes(this.props.noteType) &&
                        <span className={styles.button}>
                            <BanButton size='large' title='No Charges' onClick={() => this.noCharges()} />
                        </span>
                    }
                </div>

                {chargeNoteTypes.includes(this.props.noteType) && (this.props.alErrors) &&
                    <div className={styles.required}>
                        <br />
                        <div>The following must be completed prior to computing charges:</div>
                        <ul>
                            {this.props.alErrors &&
                                <li className={styles.compute_charges_message}>
                                    <Link to='al' containerId={this.props.noteId} spy={true} smooth={true} className={styles.required}>
                                        Complete validation of the Activity Log
                                    </Link>
                                </li>
                            }
                        </ul>
                    </div>
                }
                {(this.props.noChargesVisible || this.props.noChargeReason) &&
                    <div className={styles.row}>
                        <StatusCritical size='large' className={styles.warning} />
                        <span className={styles.nocharge_wrapper}>
                            <label className={styles.nocharge_label}>Please explain why no charges were billed for this visit.</label><br />
                            <DBTextAreaNoCharges
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'NOCHARGEREASON'}
                                className={styles.nocharge_textarea}
                                placeholder='List the exceptional circumstances that resulted in non-billable services.'
                            />
                        </span>

                    </div>
                }

                {chargeNoteTypes.includes(this.props.noteType) && this.props.computedChargesVisible &&
                    <ComputedCharges />
                }

                {this.props.chargesExist &&
                    <ActualCharges />
                }

                {this.props.validated
                    && !this.props.savingFinal
                    && !this.props.areYouSure
                    && (!this.props.chargeExist || this.props.noChargesVisible)
                    &&
                    <div className={styles.save_final}>
                        <div className={styles.save_final_row}>
                            <span className={styles.button}>
                                <SaveButton size='large' title='Save Final' onClick={() => this.saveFinal(this.props.noteType === 3 || this.props.noteType === 4 || this.props.noChargesVisible ? false : true)} />
                            </span>
                        </div>
                        {this.props.scribing &&
                            <label className={styles.scribe_warning}>You cannot save a note final while scribing.</label>
                        }
                    </div>
                }
                {this.props.validated && this.props.savingFinal &&
                    <div className={styles.save_final}>
                        <div className={styles.save_final_row}>
                            <span className={styles.button}>
                                <LoadingIcon size='large' title='Saving...' />
                            </span>
                        </div>
                    </div>
                }
                {!this.props.validated &&
                    <div className={styles.save_final}>
                        <span className={styles.button}>
                            <DoubleCheckButton size='large' title='Validate Note' onClick={() => this.validateNote()} />
                        </span>
                    </div>
                }
                {this.props.areYouSure && !this.props.savingFinal &&
                    <div>
                        <div className={styles.message}>
                            There are no appointments for the selected treatment date, are you sure?
                            <div className={styles.buttons}>
                                <span className={styles.button_wrapper}>
                                    <ApplyButton size='small' title='Yes, Save Final' onClick={() => this.saveFinal(false)} />
                                </span>
                                <span className={styles.button_wrapper}>
                                    <CancelButton size='small' title='Cancel' onClick={() => this.cancel()} />
                                </span>
                            </div>
                        </div>
                    </div>
                }
                {this.props.chargeExist && !this.props.noChargesVisible &&
                    <div>
                        <div className={styles.message}>
                            Charge(s) already exist for that date, a note cannot be saved final
                            <div className={styles.buttons}>
                                <span className={styles.button_wrapper}>
                                    <CancelButton size='small' title='Cancel' onClick={() => this.cancel()} />
                                </span>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        computeCharges: bindActionCreators(noteActions.computeCharges, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch),
        saveFinal: bindActionCreators(noteActions.saveFinal, dispatch),
        clearAptDate: bindActionCreators(noteActions.clearAptDate, dispatch),
        toggleValidationVisibility: bindActionCreators(noteActions.toggleValidationVisibility, dispatch),
        openPdf: bindActionCreators(patientActions.openPdf, dispatch),
        getNoteWarnings: bindActionCreators(noteActions.getNoteWarnings, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        setNoChargesVisible: bindActionCreators(noteActions.setNoChargesVisible, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let prefix = noteType === 1 ? 'EV' : 'NT';
    let table = noteType === 1 ? 'PTEVAL' : 'PTNOTE';
    let epno = state.entities.notes[table][pk][prefix + 'EPNO'];
    let noChargeReason = state.entities.notes[table][pk][prefix + 'NOCHARGEREASON'];
    let admission = state.entities.admissions[epno];
    let colorName = state.entities.admissions[epno].dot ? state.entities.masterData.DOTCOLORS[state.entities.admissions[epno].dot].COLORNAME : undefined;
    let insured = Object.keys(state.entities.insured)
        .filter(key => { return state.entities.insured[key].epno === epno })
        .sort((a, b) => state.entities.insured[a].position - state.entities.insured[b].position)
        .map(key => state.entities.insured[key]);
    let supvOptions = Object.keys(state.entities.notes.SUPV)
        .filter(key => state.entities.notes.SUPV[key].EPNO === epno)
        .map(key => (
            {
                id: state.entities.notes.SUPV[key].THNO,
                value: state.entities.notes.SUPV[key].THFNAME + ' ' + state.entities.notes.SUPV[key].THLNAME
            }
        ));

    let ciOptions = Object.keys(state.entities.notes.CILIST)
        .filter(key => state.entities.notes.CILIST[key].epno === epno && state.entities.notes.CILIST[key].isCI &&
            state.entities.notes.CILIST[key].thUserNo !== state.entities.authentication.user.urno)
        .map(key => (
            {
                id: state.entities.notes.CILIST[key].THNO,
                value: state.entities.notes.CILIST[key].therapistName
            }
        ));

    let islicensed = state.entities.authentication.user.islicensed;
    let alErrors = NoteValidationEngine.getWpAlErrors().length > 0 ? true : false;
    let isGroup = Object.keys(state.entities.notes.MLOTHER)
        .filter(key => {
            if (state.entities.notes.MLOTHER[key].XLOEXLNO === xlno &&
                state.entities.notes.MLOTHER[key].XLOEPERFORMED === true &&
                Object.keys(state.entities.masterData.MLMASTEROTHER)
                    .find(x => state.entities.masterData.MLMASTEROTHER[x].OENO === state.entities.notes.MLOTHER[key].XLOEOENO &&
                        state.entities.masterData.MLMASTEROTHER[x].OECODE === '97150'
                    ) !== undefined) {
                return true;
            }
            return false;
        }).length > 0 ? true : false;
    let groupErrors = isGroup && NoteValidationEngine.getGroupErrors().length > 0 ? true : false;
    let telehealthSpecified = state.entities.notes[table][pk][prefix + 'TELEHEALTH'] !== null ? true : false;
    let validated = NoteValidationEngine.getErrors().length === 0 ? true : false;
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;
    let savingFinal = state.ui.notes[noteId].savingFinal;
    let areYouSure = state.ui.notes[noteId].areYouSure;
    let chargeExist = state.ui.notes[noteId].isChargeExist;
    let noChargesVisible = state.ui.notes[noteId].noChargesVisible;
    let addUser = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVADDUSER : state.entities.notes.PTNOTE[pk].NTADDUSER;
    let scribing = addUser === state.entities.authentication.user.urno ? false : true;
    let pdfNewWindow = state.entities.masterData.PROPS['SAPPHIRE_NEWTAB_DOC'].PRVALUE === 'true' ? true : false;
    let isStudent = state.entities.authentication.user.isStudent;
    let clinicalInstructor = state.entities.authentication.user.clinicalURID === '' ? undefined : state.entities.authentication.user.clinicalURID;
    let showSupervising = !isStudent;
    let CITHNO = (noteType === 1) ? state.entities.notes.PTEVAL[pk].EVCITHNO : state.entities.notes.PTNOTE[pk].NTCITHNO;

    if (isStudent && CITHNO !== null) {
        let selectedCI = (noteType === 1) ? Object.keys(state.entities.notes.CILIST)
            .find(key => (state.entities.notes.CILIST[key].epno === epno && state.entities.notes.CILIST[key].THNO === state.entities.notes.PTEVAL[pk].EVCITHNO)) :
            Object.keys(state.entities.notes.CILIST)
                .find(key => (state.entities.notes.CILIST[key].epno === epno && state.entities.notes.CILIST[key].THNO === state.entities.notes.PTNOTE[pk].NTCITHNO));

        if (selectedCI !== undefined) {
            if (!state.entities.notes.CILIST[selectedCI].TTISLICENSED) {
                showSupervising = true;
            }
        }
    }


    let trtdate = undefined;
    if (noteType === 1) {
        trtdate = state.entities.notes.PTEVAL[pk].EVTRTDATE !== undefined ? state.entities.notes.PTEVAL[pk].EVTRTDATE : undefined;
    }
    else {
        trtdate = state.entities.notes.PTNOTE[pk].NTTRTDATE !== undefined ? state.entities.notes.PTNOTE[pk].NTTRTDATE : undefined;
    }

    let chargesExist = false;
    if (noteType === 1) {
        //do charges exist for eval?
        chargesExist = state.entities.notes.PTEVAL[pk].hasCharges ? true : false;
    }
    else {
        //do charges exist for something else
        chargesExist = state.entities.notes.PTNOTE[pk].hasCharges ? true : false;
    }

    return {
        noteId,
        noteType,
        prefix,
        table,
        pk,
        admission,
        insured,
        colorName,
        supvOptions,
        noChargeReason,
        islicensed,
        alErrors,
        groupErrors,
        isGroup,
        telehealthSpecified,
        validated,
        computedChargesVisible,
        scribing,
        epno,
        savingFinal,
        chargeExist,
        pdfNewWindow,
        trtdate,
        areYouSure,
        isStudent,
        clinicalInstructor,
        ciOptions,
        showSupervising,
        noChargesVisible,
        chargesExist
    };
}

const connectedPatientCareCenterNoteChargesBody = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteChargesBody);
export { connectedPatientCareCenterNoteChargesBody as PatientCareCenterNoteChargesBody };

